(() => {
function initializeCarousel(){
  const carousel = document.querySelector('#campaign-slideshow');
  if (!carousel || carousel.dataset.bound) return;
  carousel.dataset.bound='true';
  const controller=new AbortController();

  const slides = [...carousel.querySelectorAll('.campaign-slide')];
  const dots = [...carousel.querySelectorAll('.campaign-dot')];
  const controls = carousel.querySelector('.campaign-controls');
  const rotationButton = carousel.querySelector('#campaign-rotation');
  const slideContainer = carousel.querySelector('#campaign-slides');
  const status = carousel.querySelector('.campaign-status');
  const frame = carousel.querySelector('#package-frame');
  const worksheetTabs = [...carousel.querySelectorAll('[data-inside-worksheet]')];
  const worksheetViews = [...carousel.querySelectorAll('.inside-worksheet-view')];
  let activeIndex = 0;
  let rotationWanted = carousel.dataset.autoplay !== 'false';
  let previewOpen = false;
  let timer;
  let gesture;

  function showSlide(index, announce = false) {
    activeIndex = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => {
      slide.hidden = i !== activeIndex;
      slide.classList.toggle('is-active', i === activeIndex);
      dots[i].setAttribute('aria-current', String(i === activeIndex));
    });
    if (announce) status.textContent = slides[activeIndex].getAttribute('aria-label');
  }

  function syncRotation() {
    window.clearInterval(timer);
    rotationButton.textContent = rotationWanted ? 'Pause' : 'Play';
    rotationButton.setAttribute('aria-label', rotationWanted ? 'Pause slideshow' : 'Play slideshow');
    if (rotationWanted && !previewOpen && !document.hidden) {
      timer = window.setInterval(() => { if(!carousel.isConnected){clearInterval(timer);controller.abort();return;} showSlide(activeIndex + 1); }, Number(carousel.dataset.slideSeconds || 6)*1000);
    }
  }

  function chooseSlide(index) {
    rotationWanted = false;
    showSlide(index, true);
    syncRotation();
  }

  function showWorksheet(index, focus = false) {
    const selectedIndex = (index + worksheetTabs.length) % worksheetTabs.length;
    worksheetTabs.forEach((tab, i) => {
      const selected = i === selectedIndex;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
      worksheetViews[i].hidden = !selected;
    });
    if (focus) worksheetTabs[selectedIndex].focus();
  }

  worksheetTabs.forEach((tab, index) => {
    tab.addEventListener('click', () => showWorksheet(index));
    tab.addEventListener('keydown', event => {
      let next;
      if (event.key === 'ArrowRight') next = index + 1;
      else if (event.key === 'ArrowLeft') next = index - 1;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = worksheetTabs.length - 1;
      else return;
      event.preventDefault();
      showWorksheet(next, true);
    });
  });

  carousel.querySelectorAll('[data-slide-step]').forEach(button => {
    button.addEventListener('click', () => chooseSlide(activeIndex + Number(button.dataset.slideStep)));
  });
  dots.forEach((button, index) => button.addEventListener('click', () => chooseSlide(index)));
  rotationButton.addEventListener('click', () => {
    rotationWanted = !rotationWanted;
    syncRotation();
  });
  carousel.addEventListener('focusin', event => {
    if (!carousel.contains(event.relatedTarget) && event.target !== rotationButton) {
      rotationWanted = false;
      syncRotation();
    }
  });
  carousel.addEventListener('keydown', event => {
    if (previewOpen) return;
    let index;
    if (event.key === 'ArrowRight') index = activeIndex + 1;
    else if (event.key === 'ArrowLeft') index = activeIndex - 1;
    else if (event.key === 'Home') index = 0;
    else if (event.key === 'End') index = slides.length - 1;
    else return;
    event.preventDefault();
    chooseSlide(index);
  });
  slideContainer.addEventListener('pointerdown', event => {
    if (previewOpen || event.pointerType === 'mouse') return;
    gesture = {x: event.clientX, y: event.clientY};
  });
  slideContainer.addEventListener('pointerup', event => {
    if (!gesture || previewOpen) return;
    const dx = event.clientX - gesture.x;
    const dy = event.clientY - gesture.y;
    gesture = undefined;
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
      chooseSlide(activeIndex + (dx < 0 ? 1 : -1));
    }
  });
  slideContainer.addEventListener('pointercancel', () => { gesture = undefined; });
  frame.addEventListener('take1:preview-toggle', event => {
    previewOpen = event.detail.open;
    controls.hidden = previewOpen;
    rotationButton.hidden = previewOpen;
    slideContainer.setAttribute('aria-hidden', String(previewOpen));
    if (previewOpen) rotationWanted = false;
    syncRotation();
  });
  document.addEventListener('visibilitychange', syncRotation, {signal:controller.signal});
  document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(carousel)){clearInterval(timer);controller.abort();}}, {signal:controller.signal});
  showWorksheet(0);
  syncRotation();
}
initializeCarousel();
document.addEventListener('shopify:section:load',initializeCarousel);
})();
